export enum AuthFieldsNames {
  EMAIL = 'email',
  PASSWORD = 'password',
  CONFIRM_PASSWORD = 'password_confirmation',
}

export type TLogInFormValues = {
  [AuthFieldsNames.EMAIL]: string;
  [AuthFieldsNames.PASSWORD]: string;
};

export type TForgotPasswordFormValues = {
  [AuthFieldsNames.EMAIL]: string;
};

export type TResetPasswordFormValues = {
  [AuthFieldsNames.EMAIL]: string;
  [AuthFieldsNames.PASSWORD]: string;
  [AuthFieldsNames.CONFIRM_PASSWORD]: string;
};
